<template>
  <div class="not-found-wrapper h-100">
    <v-row class="notFoundBg pvp-lg h-100 pb-8">
      <v-container class="align-self-center fill-height">
        <v-col cols="12" class="pt-0 text-center position-relative notFoundContainerWrapper">
          <div class="notFoundContainer px-10 py-10">
            <v-img v-reload-on-fail src="/images/icons/404.png" contain height="150" />
            <div class="text-h6 my-9">Oops, page not found...</div>
            <v-row>
              <v-col cols="12" md="6" class="text-md-right pr-md-5">
                <v-btn class="border-doubled green-light large elevation-1 white--text" @click="$router.go(-1)">
                  Go Back
                </v-btn>
              </v-col>
              <v-col cols="12" md="6" class="text-md-left pl-md-5">
                <v-btn class="border-doubled gold large elevation-1 white--text" href="/contact">Contact Us</v-btn>
              </v-col>
            </v-row>
            <v-img v-reload-on-fail src="/images/icons/CloudRight.png" contain class="rightCloud" />
          </div>
          <v-img v-reload-on-fail src="/images/icons/CloudLeft.png" contain class="leftCloud" />
        </v-col>
      </v-container>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'NotFound',
  };
</script>

<style scoped>
  .notFoundBg {
    background-image: url('/images/backgrounds/dashboard-bg-min.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }

  .notFoundContainerWrapper {
    width: 80%;
    margin: auto;
    max-width: 800px;
    min-width: 0;
  }

  .notFoundContainer {
    background-image: url('/images/backgrounds/ErrorBGR.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    min-height: 50%;
    border-radius: 20px;
    box-shadow: 0 0 10px rgb(0 0 0 / 40%);
    margin: auto;
    position: relative;
    z-index: 1;
  }

  .rightCloud {
    position: absolute;
    top: -5%;
    right: -15%;
    width: 40%;
  }

  .leftCloud {
    position: absolute;
    top: 50%;
    left: -17%;
    width: 30%;
    transform: translateY(-50%);
    z-index: 0;
  }

  .not-found-wrapper {
    container: not-found / inline-size;
  }

  @container not-found (width >= 1548px) {
    .notFoundBg {
      padding-top: 40px;
    }
  }
</style>
